import styled from "styled-components";

export const DetailInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7.5px;
  align-items: flex-start;
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
`;

export const PodcastInfo = styled.div`
  color: #ffffff;
  display: flex;
  align-items: stretch;
  gap: 4px;
  line-height: normal;
  white-space: nowrap;
`;

export const PodcastRatingStar = styled.img`
  margin-right: 6px;
`;

export const PodcastDescription = styled.p`
  display: -webkit-box;
  max-width: 690px;
  min-height: 63px;
  line-height: 150%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  @media (max-width: 640px) {
    align-self: center;
  }
`;
